import service from "@/utils/request";

export function getAccountInfo(params) {
    return service({
        url: "/partnerAccountApi/getAccountInfo",
        method: "get",
        params,
    });
}

export function getAccountTopList() {
    return service({
        url: "/partnerAccountApi/getAccountTopList",
        method: "post"
    });
}
